import React from 'react';
import PropTypes from 'prop-types';
import {
  IconStar as IoStar,
  IconStarHalf as IoIosStarHalf,
  IconStarOutline as IoIosStarOutline,
} from '../IconStar/IconStar';
import classNames from 'classnames';
import css from './Ratings.module.css';

const Ratings = (props) => {
    const { rating: ratingPerUser = 5, reviews: totalRatings, className, variant, valueClassName } = props;
    const starArray = [1, 2, 3, 4, 5];
    // Calculate full stars and whether a half star is present
    const filledStars = Math.floor(ratingPerUser); // Whole number of filled stars
    const hasHalfStar = ratingPerUser % 1 !== 0;   // True if there's a fractional part (e.g., 3.5)

    // For 'sm' variant, show only one star
    const isSmallVariant = variant === 'orderPanel';

    return (
        <div className={css.ratingWrapper}>

            <div className={classNames(className, css.ratingContent)}>
                {isSmallVariant ? (
                    // Show only one filled star for small variant
                    <IoStar className={css.starIconGold} />
                ) : (
                    // Show all 5 stars for default variant
                    starArray.map(star => {
                        // Render a half star if it's the next star after the filled ones and hasHalfStar is true
                        if (star === filledStars + 1 && hasHalfStar) {
                            return <IoIosStarHalf className={css.starIconGold} key={star} />;
                        }
                        // Render filled stars for the first 'filledStars' amount
                        if (star <= filledStars) {
                            return <IoStar className={css.starIconGold} key={star} />;
                        }
                        // Render empty stars for the rest
                        return <IoIosStarOutline />;
                    })
                )}
            </div>
            <div className={classNames(css.ratingValue, valueClassName)}>
            &nbsp;{ratingPerUser.toFixed(1)}
            </div>
        </div>
    );
};

Ratings.propTypes = {
    rating: PropTypes.number,  // Rating per user (default: 5)
    reviews: PropTypes.number, // Total number of reviews
    variant: PropTypes.string, // Variant type (e.g., 'sm' for small)
    valueClassName: PropTypes.string, // Additive override for the numeric value's own typography
};

export default Ratings;
